import { render } from "./Linda_page6.vue?vue&type=template&id=50dfce2f&scoped=true"
import script from "./Linda_page6.vue?vue&type=script&lang=js"
export * from "./Linda_page6.vue?vue&type=script&lang=js"

import "./Linda_page6.vue?vue&type=style&index=0&id=50dfce2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dfce2f"]])

export default __exports__